import EllipsisVertical from './EllipsisVertical'

export default EllipsisVertical
// eslint-disable-next-line import/export
export * from './EllipsisVertical'
